<tilby-dialog-toolbar mat-dialog-title [hideConfirm]="true" [hideCancel]="true" [title]="current().title || ''"/>

<tilby-dialog-content [style.max-height]="hasUrl ? '90vh' : null">
    <section class="body" [style.width]="width()">
        <!-- Slides share one grid cell; the container height follows the active one with a transition -->
        <div class="slides" [style.height.px]="slideHeight()">
            @for (m of messages; track m.id; let i = $index) {
                <div #slide class="slide" [class.active]="i === index()" [class.url]="!!urls[i]">
                    @if (!urls[i]) {
                        <p class="message">{{ m.message }}</p>
                    } @else if (i === index()) {
                        <iframe [src]="urls[i] | safeUrl" frameborder="0" width="100%" height="100%"></iframe>
                    }
                </div>
            }
        </div>

        <mat-checkbox class="dont-show" [checked]="isHidden()" (change)="setHidden($event.checked)">
            {{"DIALOG.TILBY_MESSAGES.DONT_SHOW" | translate}}
        </mat-checkbox>

        <footer class="footer">
            <div class="back">
                @if (!isFirst()) {
                    <button mat-button (click)="prev()">{{"DIALOG.TILBY_MESSAGES.BACK" | translate}}</button>
                }
            </div>
            @if (messages.length > 1) {
                <span class="counter">{{ index() + 1 }} / {{ messages.length }}</span>
            }
            <div class="forward">
                <button mat-flat-button (click)="ok()">
                    {{(isLast() ? "DIALOG.TILBY_MESSAGES.CLOSE" : "DIALOG.TILBY_MESSAGES.NEXT") | translate}}
                </button>
            </div>
        </footer>
    </section>
</tilby-dialog-content>
